import {TYPES} from '../Actions/batchAction';

const batchReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.UPLOAD_BATCH_PROGRESS:
            return {
                ...state,
                uploadProgress: action.uploadProgress
            };
        case TYPES.UPLOAD_BATCH_SUCCESS:
            return {
                ...state,
                uploadResult: action.uploadResult
            };
        case TYPES.UPLOAD_BATCH_FINAL_SUCCESS:
            return {
                ...state,
                finalUploadResult: action.finalUploadResult
            };
        case TYPES.FETCH_ACTION_CODE_SUCCESS:
            return {
                ...state,
                actionCode: action.actionCode
            };
        case TYPES.FETCH_TEMPLATE_SUCCESS:
            return {
                ...state,
                template: action.template
            };
        default:
            return state;
    }
};

export default batchReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/batchReducer.ts